(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrival"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const EVENT = 'slideshow:select';

    function updateButtons(slideshow, prev, next) {
      const count = slideshow.slides?.length ?? 0;
      if (count <= 1) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = Boolean(slideshow.atStart);
      next.disabled = Boolean(slideshow.atEnd);
    }

    function bindSection(root) {
      if (root.dataset.newArrivalNavBound === 'true') return;
      const nav = root.querySelector('[data-new-arrival-nav]');
      const slideshow = root.querySelector('slideshow-component');
      const prev = root.querySelector('.new-arrival__nav-btn--prev');
      const next = root.querySelector('.new-arrival__nav-btn--next');
      if (!nav || !slideshow || !prev || !next) return;

      root.dataset.newArrivalNavBound = 'true';

      const refresh = () => updateButtons(slideshow, prev, next);

      prev.addEventListener('click', () => slideshow.previous?.());
      next.addEventListener('click', () => slideshow.next?.());
      slideshow.addEventListener(EVENT, refresh);
      customElements.whenDefined('slideshow-component').then(() => {
        queueMicrotask(refresh);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-testid="new-arrival"]').forEach(bindSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target;
      if (!(section instanceof HTMLElement)) return;
      const root = section.querySelector('[data-testid="new-arrival"]');
      if (root) bindSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
